// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2kWs2","buttons":"Footer_buttons__1zKnk"};